import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'user_area';
export const route = 'user_area/[[...slug]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "userarea" */
'../../components/UserArea')));